<template>
    <el-container>
        <el-main>
            <slot></slot>
        </el-main>
    </el-container>
</template>

<script>
    export default {
        name: 'auth-layout',
    }
</script>
